import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { Company } from './company';
import { HiredJob } from './hiredJob';
import { CandidateTimeSheet } from './candidateTimeSheet';
import { TimeSheetRequest } from './timesheetRequest';
@Module({ namespacedPath: 'timesheet/' })
export class TimesheetStore extends VuexModule {
  private childCompanies: Array<Company> = [];
  private jobList: Array<HiredJob> = [];
  private candidateTimeSheets: Array<CandidateTimeSheet> = [];
  private editTimeSheetId: number = 0;

  public get CandidateTimeSheets() {
    return this.candidateTimeSheets;
  }

  public get ChildCompanies() {
    return this.childCompanies;
  }

  public get JobList() {
    return this.jobList;
  }

  public get EditTimeSheetId() {
    return this.editTimeSheetId;
  }

  @mutation
  public setEditTimeSheetId(id) {
    this.editTimeSheetId = id;
  }

  @mutation
  public setCandidateTimeSheets(payload) {
    this.candidateTimeSheets = payload;
  }

  @mutation
  public setChildCompanies(payload) {
    this.childCompanies = payload;
  }

  @mutation
  public setJobList(payload) {
    this.jobList = payload;
  }

  @action({ mode: 'mutate' })
  fetchTimesheet() {}

  @action({ mode: 'mutate' })
  public async fetchChildCompanies() {
    const response = await axios.post(
      '/wl-timeentry-service/api/candidate/getchildcompanies',
      {
        companyCode: vxm.jobs.BrandingInfo.companycode,
        searchText: '',
        pageNumber: 1,
        pageSize: 10,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setChildCompanies(response.data.data.content);
    return response;
  }

  @action({ mode: 'mutate' })
  public async fetchJobList(companyCode) {
    const response = await axios.post(
      '/wl-timeentry-service/api/candidate/getjoblist',
      {
        companyCode,
        searchText: '',
        pageNumber: 1,
        pageSize: 10,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );

    this.setJobList(response.data.data.content);
    return response;
  }

  @action({ mode: 'mutate' })
  public async fetchCandidateTimeSheets(tab) {
    const response = await axios.post(
      '/wl-timeentry-service/api/candidate/timesheets',
      {
        status: tab,
        searchText: '',
        pageNumber: 1,
        pageSize: 100,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setCandidateTimeSheets(response.data.data.candidateTimeSheets);
    return response;
  }

  @action({ mode: 'mutate' })
  public async saveTimesheet(payload) {
    const timesheetUrl = '/wl-timeentry-service/api/candidate/timesheet';
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    };
    const resp = await axios.post(timesheetUrl, payload, config);
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async editTimesheet(payload) {
    const timesheetUrl = '/wl-timeentry-service/api/candidate/timesheet/update';
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: bearerToken,
      },
    };
    const resp = await axios.post(timesheetUrl, payload, config);
    return resp.data;
  }
  @action({ mode: 'mutate' })
  public async filterCandidateTimeSheets(timesheetRequest: TimeSheetRequest) {
    const response = await axios.post(
      '/wl-timeentry-service/api/candidate/timesheets',
      {
        status: timesheetRequest.tabName,
        searchText: timesheetRequest.searchText,
        startDate: timesheetRequest.startDate,
        endDate: timesheetRequest.endDate,
        pageNumber: timesheetRequest.pageNumber,
        pageSize: timesheetRequest.pageSize,
      },
      {
        headers: {
          Authorization: `Bearer ${vxm.users.getToken}`,
        },
      },
    );
    this.setCandidateTimeSheets(response.data.data.candidateTimeSheets);
    return response;
  }
}
